<template>
  <div>
    <div class="box box-primary" style="height: 100vh;">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t("reward.title") }}</h3>
      </div>

      <div class="box-body">
        <div class="container-fluid" style="padding: 0">
          <span
            style="display:flex; justify-content: space-between; align-items: baseline;"
          >
            <label class="label_title" for="name">{{
              $t("reward.sub_title")
            }}</label>
            <button
              class="btn btn-primary"
              style="margin-right: 2rem;"
              @click="onInstall"
            >
              {{ $t("reward.setup") }}
            </button>
          </span>
          <div class="row">
            <div style="margin-top: 2rem;">
              <div class="col-md-3 col-sm-3 col-3 text-center">
                <span style="font-size:150px;color:#70AD47;">&#9733;</span>
                <h3>{{ $t("reward.bronze") }}</h3>
                <h4>{{ $t("reward.reward_point") }} {{ reward.bronze }}</h4>
              </div>
              <div class="col-md-3 col-sm-3 col-3 text-center">
                <span style="font-size:150px;color:#B5B5B5;">&#9733;</span>
                <h3>{{ $t("reward.silver") }}</h3>
                <h4>{{ $t("reward.reward_point") }} {{ reward.silver }}</h4>
              </div>
              <div class="col-md-3 col-sm-3 col-3 text-center">
                <span style="font-size:150px;color:#FFC000;">&#9733;</span>
                <h3>{{ $t("reward.gold") }}</h3>
                <h4>{{ $t("reward.reward_point") }} {{ reward.gold }}</h4>
              </div>
              <div class="col-md-3 col-sm-3 col-3 text-center">
                <span style="font-size:150px;color:#5B9BD5;">&#9733;</span>
                <h3>{{ $t("reward.platinum") }}</h3>
                <h4>{{ $t("reward.reward_point") }} {{ reward.platinum }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal modal-set-reward -->
      <div class="modal fade" :ref="`modal-setup-reward`">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">{{ $t("reward.setup") }}</h4>
            </div>
            <div class="modal-body">
              <div class="row mb-1 margin-down-15">
                <div>
                  <label
                    for="statictype"
                    style="margin-left: 4rem;"
                    class="col-md-3 col-sm-3 col-form-label"
                    >{{ $t("reward.type") }}</label
                  >
                  <label for="">{{ $t("reward.reward_point") }}</label>
                </div>
                <div style="margin-top: 2rem;">
                  <label
                    for="bronze"
                    style="margin-left: 4rem;"
                    class="col-md-3 col-sm-3 col-form-label"
                    >{{ $t("reward.bronze") }}</label
                  >
                  <input
                    v-model="reward.bronze"
                    type="number"
                    min="0"
                    style="text-align:right;"
                  />
                </div>
                <div style="margin-top: 2rem;">
                  <label
                    for="silver"
                    style="margin-left: 4rem;"
                    class="col-md-3 col-sm-3 col-form-label"
                    >{{ $t("reward.silver") }}</label
                  >
                  <input
                    v-model="reward.silver"
                    type="number"
                    min="0"
                    style="text-align:right;"
                  />
                </div>
                <div style="margin-top: 2rem;">
                  <label
                    for="gold"
                    style="margin-left: 4rem;"
                    class="col-md-3 col-sm-3 col-form-label"
                    >{{ $t("reward.gold") }}</label
                  >
                  <input
                    v-model="reward.gold"
                    type="number"
                    min="0"
                    style="text-align:right;"
                  />
                </div>
                <div style="margin-top: 2rem;">
                  <label
                    for="platinum"
                    style="margin-left: 4rem;"
                    class="col-md-3 col-sm-3 col-form-label"
                    >{{ $t("reward.platinum") }}</label
                  >
                  <input
                    v-model="reward.platinum"
                    type="number"
                    min="0"
                    style="text-align:right;"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                style="background-color: #f29911;border-color: #f29911;color:#fff"
                type="button"
                class="btn btn-default pull-left"
                data-dismiss="modal"
              >
                {{ $t("common.back") }}
              </button>
              <button type="button" class="btn btn-primary" @click="save">
                {{ $t("common.save") }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <lte-core-alert
        v-for="snackbar in GET_SNACK_BAR"
        :key="snackbar.id"
        :item="snackbar"
      >
      </lte-core-alert>

      <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF">
      </loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import constantData from "@/lib/constantsData";
import utils from '@/lib/utils'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";

export default {
  name: "RewardPointManagement",
  data() {
    return {
      isLoading: false,
      reward: {
        bronze: 0,
        silver: 0,
        gold: 0,
        platinum: 0
      }
    };
  },
  watch: {
    GET_REWARD_POINT_DATA: function() {
      for (let i = 0, size = this.GET_REWARD_POINT_DATA.length; i < size; i++) {
        if (
          this.GET_REWARD_POINT_DATA[i].name == constantData.RewardPoint.BRONZE
        ) {
          this.reward.bronze = this.GET_REWARD_POINT_DATA[i].reward_point;
        } else if (
          this.GET_REWARD_POINT_DATA[i].name == constantData.RewardPoint.SILVER
        ) {
          this.reward.silver = this.GET_REWARD_POINT_DATA[i].reward_point;
        } else if (
          this.GET_REWARD_POINT_DATA[i].name == constantData.RewardPoint.GOLD
        ) {
          this.reward.gold = this.GET_REWARD_POINT_DATA[i].reward_point;
        } else if (
          this.GET_REWARD_POINT_DATA[i].name ==
          constantData.RewardPoint.PLATINUM
        ) {
          this.reward.platinum = this.GET_REWARD_POINT_DATA[i].reward_point;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_REWARD_POINT_DATA",
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_REWARD_POINT",
      "UPDATE_REWARD_POINT",
      "SUCCESS_TOAST",
      "ERROR_TOAST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onInstall: function() {
      $(this.$refs["modal-setup-reward"]).modal("show");
    },
    save: function() {
      let data = {
        bronze: parseInt(this.reward.bronze),
        silver: parseInt(this.reward.silver),
        gold: parseInt(this.reward.gold),
        platinum: parseInt(this.reward.platinum)
      };
      this.isLoading = true;
      this.UPDATE_REWARD_POINT(data)
        .then(
          function() {
            $(this.$refs["modal-setup-reward"]).modal("hide");
            this.SUCCESS_TOAST();
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ERROR_TOAST();
          }.bind(this)
        );
    }
  },
  mounted() {
    this.GET_REWARD_POINT();
  },
  components: {
    loading: Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>

<style>
.label_title {
  text-align: center;
  font-size: 15px;
  text-align: left;
  color: #5b6c7f;
  margin-bottom: 20px;
  margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Project/RewardPointManagement.vue